export default __webpack_public_path__ + "static/media/Opportunity-empty-state-icon.8bc703e6.svg";